import React from 'react';
import CountUp from './CountUp';
import styles from './customerFeedback.module.scss';
import LargeWidthContainer from '../Layout/Containers/LargeWidthContainer';
import FullWidthContainer from '../Layout/Containers/FullWidthContainer';

export interface FeedbackStat {
    score: number;
    max: number;
    label: string;
}

export interface ExperienceItem {
    tag: string;
    title: string;
    description: string;
}

const defaultStats: FeedbackStat[] = [
    { score: 4.7, max: 5, label: 'Quality, meeting deadlines and collaboration' },
    { score: 4.6, max: 5, label: 'Business understanding' },
];

const defaultExperience: ExperienceItem[] = [
    {
        tag: 'Data platform',
        title: 'Rebuilding a data platform',
        description:
            "Noria rebuilt a client's data platform in Microsoft Fabric and introduced AI-supported development practices.",
    },
    {
        tag: 'Quality assurance',
        title: 'Automating quality assurance',
        description:
            'For a banking client, Noria replaced manual spot checks on loan cases with 51 automated daily tests.',
    },
];

interface CustomerFeedbackProps {
    stats?: FeedbackStat[];
    experience?: ExperienceItem[];
}

const CustomerFeedbackComponent = ({
    stats = defaultStats,
    experience = defaultExperience,
}: CustomerFeedbackProps) => {
    return (
        <FullWidthContainer extraClassNames={styles.customerFeedback}>
            <div className="container">
                <span className={styles.eyebrow}>Customer feedback</span>
                <h2 className={styles.heading}>What customers value in our consultants</h2>

                <div className={styles.stats}>
                    {stats.map((stat) => (
                        <div key={stat.label} className={styles.stat}>
                            <span className={styles.statValue}>
                                <CountUp end={stat.score} decimals={1} /> / {stat.max}
                            </span>
                            <span className={styles.statLabel}>{stat.label}</span>
                        </div>
                    ))}
                </div>

                <div className={styles.experienceHead}>
                    <h3>Selected experience</h3>
                    <p>Examples of Noria&apos;s work with data platforms and quality assurance.</p>
                </div>
                <div className={styles.experience}>
                    {experience.map((item) => (
                        <div key={item.title} className={styles.experienceCard}>
                            <span className={styles.tag}>{item.tag}</span>
                            <h4>{item.title}</h4>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </FullWidthContainer>
    );
};

export default CustomerFeedbackComponent;
